'use strict';

var _defineProperty = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var classNames = require('classnames');

var rdk = require('rdk');

var framerMotion = require('framer-motion');

var FocusTrap = require('focus-trap-react');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

var FocusTrap__default = /*#__PURE__*/_interopDefaultLegacy(FocusTrap);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".Tooltip-module_tooltip__2A0zj {\n  background: var(--color-tooltip);\n  border-radius: 5px;\n  color: var(--color-on-tooltip);\n  padding: 7px;\n  white-space: nowrap;\n  text-align: center;\n  will-change: transform, opacity;\n}\n\n.Tooltip-module_disablePointer__1V598 {\n  pointer-events: none;\n}\n";
var css = {
  "tooltip": "Tooltip-module_tooltip__2A0zj",
  "disablePointer": "Tooltip-module_disablePointer__1V598"
};
styleInject(css_248z);
var tooltips = [];

var Tooltip = function Tooltip(_a) {
  var className = _a.className,
      children = _a.children,
      _content = _a.content,
      _a$disabled = _a.disabled,
      disabled = _a$disabled === void 0 ? false : _a$disabled,
      _a$enterDelay = _a.enterDelay,
      enterDelay = _a$enterDelay === void 0 ? 0 : _a$enterDelay,
      _a$leaveDelay = _a.leaveDelay,
      leaveDelay = _a$leaveDelay === void 0 ? 200 : _a$leaveDelay,
      _a$placement = _a.placement,
      placement = _a$placement === void 0 ? 'top' : _a$placement,
      _a$trigger = _a.trigger,
      trigger = _a$trigger === void 0 ? 'hover' : _a$trigger,
      _a$visible = _a.visible,
      visible = _a$visible === void 0 ? false : _a$visible,
      _a$followCursor = _a.followCursor,
      followCursor = _a$followCursor === void 0 ? false : _a$followCursor,
      _a$closeOnClick = _a.closeOnClick,
      closeOnClick = _a$closeOnClick === void 0 ? false : _a$closeOnClick,
      _a$closeOnEscape = _a.closeOnEscape,
      closeOnEscape = _a$closeOnEscape === void 0 ? true : _a$closeOnEscape,
      _a$closeOnBodyClick = _a.closeOnBodyClick,
      closeOnBodyClick = _a$closeOnBodyClick === void 0 ? true : _a$closeOnBodyClick,
      _a$pointerEvents = _a.pointerEvents,
      pointerEvents = _a$pointerEvents === void 0 ? 'none' : _a$pointerEvents,
      rest = __rest(_a, ["className", "children", "content", "disabled", "enterDelay", "leaveDelay", "placement", "trigger", "visible", "followCursor", "closeOnClick", "closeOnEscape", "closeOnBodyClick", "pointerEvents"]);

  var _React$useState = React.useState(visible),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      internalVisible = _React$useState2[0],
      setInternalVisible = _React$useState2[1];

  var timeout = React.useRef();
  var mounted = React.useRef(false);
  var ref = React.useRef(setInternalVisible);
  React.useEffect(function () {
    // componentDidUpdateLogic style logic
    if (!mounted.current) {
      mounted.current = true;
    } else {
      setInternalVisible(visible);
    }

    return function () {
      clearTimeout(timeout.current);
      deactivate();
    };
  }, [visible]);
  var deactivateAll = React.useCallback(function () {
    return tooltips.forEach(function (r, i) {
      r(false);
      tooltips.splice(i, 1);
    });
  }, []);
  var deactivate = React.useCallback(function () {
    var idx = tooltips.indexOf(ref.current);

    if (idx > -1) {
      setInternalVisible(false);
      tooltips.splice(idx, 1);
    }
  }, []);
  return React__default['default'].createElement(rdk.ConnectedOverlay, Object.assign({}, rest, {
    placement: placement,
    trigger: trigger,
    followCursor: followCursor,
    portalClassName: classNames__default['default'](_defineProperty({}, css.disablePointer, pointerEvents === 'none')),
    open: internalVisible,
    closeOnBodyClick: closeOnBodyClick,
    closeOnEscape: closeOnEscape,
    content: function content() {
      var contentChildren = typeof _content === 'function' ? _content() : _content;

      if (!contentChildren) {
        return null;
      }

      return React__default['default'].createElement(framerMotion.motion.div, {
        className: classNames__default['default'](css.tooltip, className),
        initial: {
          opacity: 0,
          scale: 0.3,
          transition: {
            when: 'beforeChildren'
          }
        },
        animate: {
          opacity: 1,
          scale: 1,
          transition: {
            when: 'beforeChildren'
          }
        },
        exit: {
          opacity: 0,
          scale: 0.3
        },
        onClick: function onClick() {
          if (closeOnClick) {
            deactivateAll();
          }
        }
      }, contentChildren);
    },
    onOpen: function onOpen() {
      if (!internalVisible) {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
          if (!disabled) {
            deactivateAll();
            setInternalVisible(true);
            tooltips.push(ref.current);
          }
        }, enterDelay);
      }
    },
    onClose: function onClose() {
      clearTimeout(timeout.current);
      timeout.current = setTimeout(function () {
        return deactivate();
      }, leaveDelay);
    }
  }), children);
};

var css_248z$1 = ".Popover-module_popover__37iIL {\n  background: var(--color-popover);\n  border-radius: 2px;\n  color: var(--color-on-popover);\n  padding: 14px;\n  will-change: transform, opacity;\n}\n\n  .Popover-module_popover__37iIL.Popover-module_disablePadding__3vGRW {\n    padding: 0;\n  }\n";
var css$1 = {
  "popover": "Popover-module_popover__37iIL",
  "disablePadding": "Popover-module_disablePadding__3vGRW"
};
styleInject(css_248z$1);

var Popover = function Popover(_a) {
  var _a$closeOnEscape2 = _a.closeOnEscape,
      closeOnEscape = _a$closeOnEscape2 === void 0 ? true : _a$closeOnEscape2,
      _a$closeOnBodyClick2 = _a.closeOnBodyClick,
      closeOnBodyClick = _a$closeOnBodyClick2 === void 0 ? true : _a$closeOnBodyClick2,
      _a$trigger2 = _a.trigger,
      trigger = _a$trigger2 === void 0 ? 'click' : _a$trigger2,
      _a$leaveDelay2 = _a.leaveDelay,
      leaveDelay = _a$leaveDelay2 === void 0 ? 200 : _a$leaveDelay2,
      children = _a.children,
      _content2 = _a.content,
      className = _a.className,
      disablePadding = _a.disablePadding,
      popoverStyle = _a.popoverStyle,
      popoverClassName = _a.popoverClassName,
      rest = __rest(_a, ["closeOnEscape", "closeOnBodyClick", "trigger", "leaveDelay", "children", "content", "className", "disablePadding", "popoverStyle", "popoverClassName"]);

  var id = rdk.useId();
  return React__default['default'].createElement(Tooltip, Object.assign({}, rest, {
    trigger: trigger,
    pointerEvents: "initial",
    leaveDelay: leaveDelay,
    className: classNames__default['default'](css$1.popover, _defineProperty({}, css$1.disablePadding, disablePadding)),
    content: function content() {
      var isContentFunction = typeof _content2 === 'function';
      var children = isContentFunction ? _content2() : _content2;

      if (!children) {
        return null;
      }

      return React__default['default'].createElement(FocusTrap__default['default'], {
        focusTrapOptions: {
          escapeDeactivates: true,
          clickOutsideDeactivates: true,
          fallbackFocus: "#".concat(id)
        }
      }, React__default['default'].createElement("div", {
        id: id,
        "tab-index": "-1",
        stlye: popoverStyle,
        className: popoverClassName
      }, children));
    }
  }), children);
};

var css_248z$2 = ".Dialog-module_dialog__3eIDR {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  pointer-events: none;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  will-change: transform, opacity;\n}\n\n  .Dialog-module_dialog__3eIDR.Dialog-module_disableHeader__3cwG5 .Dialog-module_content__1qwq9 {\n      padding: 20px;\n    }\n\n  .Dialog-module_dialog__3eIDR.Dialog-module_disablePadding__1FoaN .Dialog-module_content__1qwq9,\n    .Dialog-module_dialog__3eIDR.Dialog-module_disablePadding__1FoaN .Dialog-module_header__292Tt {\n      padding: 0;\n    }\n\n  .Dialog-module_dialog__3eIDR .Dialog-module_inner__22ThE {\n    background: var(--color-dialog);\n    color: var(--color-on-dialog);\n    box-sizing: border-box;\n    outline: 0;\n    pointer-events: auto;\n    max-width: 80vw;\n    max-height: 80vh;\n    overflow: auto;\n  }\n\n  .Dialog-module_dialog__3eIDR .Dialog-module_header__292Tt {\n    display: flex;\n    padding: 20px 20px 10px 20px;\n  }\n\n  .Dialog-module_dialog__3eIDR .Dialog-module_header__292Tt .Dialog-module_headerText__2LqjF {\n      margin: 0;\n      padding: 0;\n      flex: 1;\n      display: inline-flex;\n    }\n\n  .Dialog-module_dialog__3eIDR .Dialog-module_header__292Tt .Dialog-module_closeButton__LNtbX {\n      margin: 0 0 0 15px;\n      opacity: 0.8;\n      height: auto;\n      width: auto;\n      min-width: auto;\n      min-height: auto;\n      display: inline-flex;\n      padding: 0;\n      background: none;\n      border: none;\n      cursor: pointer;\n      align-items: center;\n      color: var(--color-on-dialog);\n      font-size: 16px;\n    }\n\n  .Dialog-module_dialog__3eIDR .Dialog-module_header__292Tt .Dialog-module_closeButton__LNtbX:focus {\n        outline: none;\n      }\n\n  .Dialog-module_dialog__3eIDR .Dialog-module_content__1qwq9 {\n    padding: 10px 20px 20px 20px;\n  }\n";
var css$2 = {
  "dialog": "Dialog-module_dialog__3eIDR",
  "disableHeader": "Dialog-module_disableHeader__3cwG5",
  "content": "Dialog-module_content__1qwq9",
  "disablePadding": "Dialog-module_disablePadding__1FoaN",
  "header": "Dialog-module_header__292Tt",
  "inner": "Dialog-module_inner__22ThE",
  "headerText": "Dialog-module_headerText__2LqjF",
  "closeButton": "Dialog-module_closeButton__LNtbX"
};
styleInject(css_248z$2);

var Dialog = function Dialog(_ref) {
  var children = _ref.children,
      open = _ref.open,
      className = _ref.className,
      header = _ref.header,
      onClose = _ref.onClose,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? '50%' : _ref$size,
      _ref$disablePadding = _ref.disablePadding,
      disablePadding = _ref$disablePadding === void 0 ? false : _ref$disablePadding,
      _ref$hasBackdrop = _ref.hasBackdrop,
      hasBackdrop = _ref$hasBackdrop === void 0 ? true : _ref$hasBackdrop,
      _ref$showCloseButton = _ref.showCloseButton,
      showCloseButton = _ref$showCloseButton === void 0 ? true : _ref$showCloseButton,
      _ref$closeOnBackdropC = _ref.closeOnBackdropClick,
      closeOnBackdropClick = _ref$closeOnBackdropC === void 0 ? true : _ref$closeOnBackdropC,
      _ref$closeOnEscape = _ref.closeOnEscape,
      closeOnEscape = _ref$closeOnEscape === void 0 ? true : _ref$closeOnEscape;
  var id = rdk.useId();
  return React__default['default'].createElement(rdk.GlobalOverlay, {
    open: open,
    hasBackdrop: hasBackdrop,
    closeOnEscape: closeOnEscape,
    closeOnBackdropClick: closeOnBackdropClick,
    onClose: onClose
  }, function (_ref2) {
    var _classNames__default$3;

    var overlayIndex = _ref2.overlayIndex;
    return React__default['default'].createElement(FocusTrap__default['default'], {
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
        fallbackFocus: "#".concat(id, "-content")
      }
    }, React__default['default'].createElement("div", {
      id: id,
      "tab-index": "-1"
    }, React__default['default'].createElement(framerMotion.motion.div, {
      initial: {
        opacity: 0,
        y: '-20%'
      },
      animate: {
        opacity: 1,
        y: 0
      },
      exit: {
        opacity: 0,
        y: '20%'
      },
      transition: {
        duration: 0.5,
        ease: [0.04, 0.62, 0.23, 0.98]
      },
      style: {
        zIndex: overlayIndex
      },
      className: classNames__default['default'](css$2.dialog, className, (_classNames__default$3 = {}, _defineProperty(_classNames__default$3, css$2.disableHeader, !header), _defineProperty(_classNames__default$3, css$2.disablePadding, disablePadding), _classNames__default$3))
    }, React__default['default'].createElement("div", {
      className: css$2.inner,
      style: {
        width: size
      }
    }, header && React__default['default'].createElement("header", {
      className: css$2.header
    }, React__default['default'].createElement("h1", {
      className: css$2.headerText
    }, header), showCloseButton && React__default['default'].createElement("button", {
      type: "button",
      className: css$2.closeButton,
      onClick: onClose
    }, "\u2715")), React__default['default'].createElement("section", {
      id: "".concat(id, "-content"),
      className: css$2.content
    }, typeof children === 'function' ? children() : children)))));
  });
};

var useDialog = function useDialog(prop) {
  var _ref3 = prop || {},
      open = _ref3.open,
      onClose = _ref3.onClose;

  var _React$useState3 = React.useState(open),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      internalOpen = _React$useState4[0],
      setInternalOpen = _React$useState4[1];

  React.useEffect(function () {
    setInternalOpen(open);
  }, [open]);
  var onCloseInternal = React.useCallback(function () {
    setInternalOpen(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);

  var onToggleOpen = function onToggleOpen() {
    setInternalOpen(!open);
  };

  var Component = React.useCallback(function (props) {
    return React__default['default'].createElement(Dialog, Object.assign({}, props, {
      open: internalOpen,
      onClose: onCloseInternal
    }));
  }, [internalOpen, onCloseInternal]);
  return {
    isOpen: internalOpen,
    setOpen: setInternalOpen,
    toggleOpen: onToggleOpen,
    Dialog: Component
  };
};

var variants = {
  start: {
    initial: {
      x: '-100%'
    },
    animate: {
      x: '0%'
    }
  },
  end: {
    initial: {
      x: '100%'
    },
    animate: {
      x: '0%'
    }
  },
  top: {
    initial: {
      y: '-100%'
    },
    animate: {
      y: '0%'
    }
  },
  bottom: {
    initial: {
      y: '100%'
    },
    animate: {
      y: '0%'
    }
  }
};
var css_248z$3 = ".Drawer-module_drawer__17v12 {\n  position: fixed;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: var(--color-drawer);\n  color: var(--color-on-drawer);\n}\n\n  .Drawer-module_drawer__17v12:not(.Drawer-module_disablePadding__EhMMY) .Drawer-module_content__Ky_ZR {\n      padding: 20px 30px;\n    }\n\n  .Drawer-module_drawer__17v12 .Drawer-module_header__UZcJu {\n    display: flex;\n    align-items: center;\n    padding: 20px 30px;\n  }\n\n  .Drawer-module_drawer__17v12 .Drawer-module_header__UZcJu > h1 {\n      margin: 0;\n      flex: 1;\n    }\n\n  .Drawer-module_drawer__17v12 .Drawer-module_closeButton__3FEQA {\n    opacity: 0.8;\n    height: auto;\n    width: auto;\n    min-width: auto;\n    min-height: auto;\n    padding: 0;\n    background: none;\n    border: none;\n    cursor: pointer;\n    color: var(--color-on-drawer);\n    font-size: 16px;\n  }\n\n  .Drawer-module_drawer__17v12 .Drawer-module_closeButton__3FEQA:focus {\n      outline: none;\n    }\n\n  .Drawer-module_drawer__17v12 .Drawer-module_closeButton__3FEQA.Drawer-module_headerlessCloseButton__UEH_K {\n      position: absolute;\n      top: 20px;\n      right: 20px;\n    }\n\n  .Drawer-module_drawer__17v12.Drawer-module_start__qtGuQ,\n  .Drawer-module_drawer__17v12.Drawer-module_end__quCxe {\n    top: 0;\n    bottom: 0;\n    height: 100%;\n  }\n\n  .Drawer-module_drawer__17v12.Drawer-module_start__qtGuQ {\n    left: 0;\n  }\n\n  .Drawer-module_drawer__17v12.Drawer-module_end__quCxe {\n    right: 0;\n  }\n\n  .Drawer-module_drawer__17v12.Drawer-module_top__1xtVG,\n  .Drawer-module_drawer__17v12.Drawer-module_bottom__DKQ-u {\n    width: 100%;\n    left: 0;\n    right: 0;\n  }\n\n  .Drawer-module_drawer__17v12.Drawer-module_top__1xtVG {\n    top: 0;\n  }\n\n  .Drawer-module_drawer__17v12.Drawer-module_bottom__DKQ-u {\n    bottom: 0;\n  }\n\n[dir=\"ltr\"] :export {\n  start-top: Drawer-module_start__qtGuQ;\n  start-left: Drawer-module_start__qtGuQ;\n}\n\n[dir=\"rtl\"] :export {\n  start-top: Drawer-module_start__qtGuQ;\n  start-right: Drawer-module_start__qtGuQ;\n}\n\n[dir=\"ltr\"] :export {\n  end-bottom: Drawer-module_end__quCxe;\n  end-right: Drawer-module_end__quCxe;\n}\n\n[dir=\"rtl\"] :export {\n  end-bottom: Drawer-module_end__quCxe;\n  end-left: Drawer-module_end__quCxe;\n}\n";
var css$3 = {
  "drawer": "Drawer-module_drawer__17v12",
  "disablePadding": "Drawer-module_disablePadding__EhMMY",
  "content": "Drawer-module_content__Ky_ZR",
  "header": "Drawer-module_header__UZcJu",
  "closeButton": "Drawer-module_closeButton__3FEQA",
  "headerlessCloseButton": "Drawer-module_headerlessCloseButton__UEH_K",
  "top": "Drawer-module_top__1xtVG",
  "bottom": "Drawer-module_bottom__DKQ-u"
};
styleInject(css_248z$3);

var Drawer = function Drawer(_ref4) {
  var className = _ref4.className,
      children = _ref4.children,
      open = _ref4.open,
      backdropClassName = _ref4.backdropClassName,
      header = _ref4.header,
      _ref4$position = _ref4.position,
      position = _ref4$position === void 0 ? 'end' : _ref4$position,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? '80%' : _ref4$size,
      _ref4$hasBackdrop = _ref4.hasBackdrop,
      hasBackdrop = _ref4$hasBackdrop === void 0 ? true : _ref4$hasBackdrop,
      _ref4$closeOnEscape = _ref4.closeOnEscape,
      closeOnEscape = _ref4$closeOnEscape === void 0 ? true : _ref4$closeOnEscape,
      _ref4$closeOnBackdrop = _ref4.closeOnBackdropClick,
      closeOnBackdropClick = _ref4$closeOnBackdrop === void 0 ? true : _ref4$closeOnBackdrop,
      _ref4$disablePadding = _ref4.disablePadding,
      disablePadding = _ref4$disablePadding === void 0 ? false : _ref4$disablePadding,
      _ref4$showCloseButton = _ref4.showCloseButton,
      showCloseButton = _ref4$showCloseButton === void 0 ? true : _ref4$showCloseButton,
      _ref4$onClose = _ref4.onClose,
      onClose = _ref4$onClose === void 0 ? function () {
    return undefined;
  } : _ref4$onClose;
  var id = rdk.useId();
  var variant = variants[position];
  var style = {
    width: position === 'start' || position === 'end' ? size : 'auto',
    height: position === 'top' || position === 'bottom' ? size : 'auto'
  };
  return React__default['default'].createElement(rdk.GlobalOverlay, {
    open: open,
    hasBackdrop: hasBackdrop,
    closeOnEscape: closeOnEscape,
    closeOnBackdropClick: closeOnBackdropClick,
    onClose: onClose,
    backdropClassName: backdropClassName
  }, function (_ref5) {
    var overlayIndex = _ref5.overlayIndex;
    return React__default['default'].createElement(FocusTrap__default['default'], {
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,
        fallbackFocus: "#".concat(id)
      }
    }, React__default['default'].createElement("div", {
      id: id,
      "tab-index": "-1"
    }, React__default['default'].createElement(framerMotion.motion.div, {
      initial: "initial",
      animate: "animate",
      exit: "initial",
      variants: variant,
      transition: {
        duration: 0.5,
        ease: [0.04, 0.62, 0.23, 0.98],
        when: 'beforeChildren'
      },
      style: Object.assign(Object.assign({}, style), {
        zIndex: overlayIndex
      }),
      className: classNames__default['default'](css$3.drawer, className, css$3[position], _defineProperty({}, css$3.disablePadding, disablePadding))
    }, header && React__default['default'].createElement("header", {
      className: css$3.header
    }, React__default['default'].createElement("h1", null, header), showCloseButton && React__default['default'].createElement("button", {
      type: "button",
      className: css$3.closeButton,
      onClick: onClose
    }, "\u2715")), !header && showCloseButton && React__default['default'].createElement("button", {
      type: "button",
      className: classNames__default['default'](css$3.closeButton, css$3.headerlessCloseButton),
      onClick: onClose
    }, "\u2715"), React__default['default'].createElement("div", {
      className: css$3.content
    }, typeof children === 'function' ? children() : children))));
  });
};

var useDrawer = function useDrawer(prop) {
  var _ref6 = prop || {},
      open = _ref6.open,
      onClose = _ref6.onClose;

  var _React$useState5 = React.useState(open),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      internalOpen = _React$useState6[0],
      setInternalOpen = _React$useState6[1];

  React.useEffect(function () {
    setInternalOpen(open);
  }, [open]);
  var onCloseInternal = React.useCallback(function () {
    setInternalOpen(false);
    onClose === null || onClose === void 0 ? void 0 : onClose();
  }, [onClose]);

  var onToggleOpen = function onToggleOpen() {
    setInternalOpen(!internalOpen);
  };

  var Component = React.useCallback(function (props) {
    return React__default['default'].createElement(Drawer, Object.assign({}, props, {
      open: internalOpen,
      onClose: onCloseInternal
    }));
  }, [internalOpen, onCloseInternal]);
  return {
    isOpen: internalOpen,
    setOpen: setInternalOpen,
    toggleOpen: onToggleOpen,
    Drawer: Component
  };
};

exports.Dialog = Dialog;
exports.Drawer = Drawer;
exports.Popover = Popover;
exports.Tooltip = Tooltip;
exports.useDialog = useDialog;
exports.useDrawer = useDrawer;